import { useErrorHandling } from 'ra-core'
import { FC, useEffect, useMemo, useState } from 'react'
import { http } from '../../services/http'
import Resources from './Resources'
import ResourcesModal, { ResourceGroup } from './ResourcesModal'

interface PropTypes {
  standId: number
  onExpand?: () => void
  onResourceClick?: (url: string) => void
}

const ExhibitResources: FC<PropTypes> = ({ standId, onExpand, onResourceClick }) => {
  const errorHandling = useErrorHandling()
  // Combined resources (Showcase spec sheets + partner-managed), grouped by product.
  const [resourceGroups, setResourceGroups] = useState<ResourceGroup[]>([])
  const [modalOpen, setModalOpen] = useState(false)

  useEffect(() => {
    if (!standId) return

    http.os
      .get(`partners/expo_stand_resources_public/${standId}/`)
      .then((res) => {
        if (Array.isArray(res.data)) setResourceGroups(res.data)
      })
      .catch((err) => {
        errorHandling.data_provider(err, { msg: 'Failed to fetch expo stand resources' })
      })
  }, [standId, errorHandling])

  // Flattened preview list across all product groups for the on-stand slider.
  const previewResources = useMemo(
    () =>
      resourceGroups.flatMap((group) =>
        group.resources.map((resource) => ({
          id: resource.id,
          title: resource.file_name,
          url: resource.url,
        }))
      ),
    [resourceGroups]
  )

  const handleExpand = () => {
    setModalOpen(true)
    onExpand?.()
  }

  return (
    <>
      <Resources resources={previewResources} onExpand={handleExpand} onResourceClick={onResourceClick} />
      <ResourcesModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        groups={resourceGroups}
        onResourceClick={onResourceClick}
      />
    </>
  )
}

export default ExhibitResources
